import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";

import './index.css';
import './assets/css/aip.css';
import './assets/css/branding.css';
import './assets/css/Login.css';
import './assets/css/nav.css';
import './assets/css/notifications.css';
import './assets/css/sidenav.css';
import './assets/css/Style.css';
import './assets/css/search.css';
import './assets/css/responsive.css';
import './assets/css/spinner.css'
import './App.css';
import 'react-loading-skeleton/dist/skeleton.css'
import 'react-toastify/dist/ReactToastify.css';

import App from './App';
import { applyUiConfig } from './config/uiConfig';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

applyUiConfig();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
//   <React.StrictMode>
//   <BrowserRouter>
//     <App />
//   </BrowserRouter>
// </React.StrictMode>
<>
<BrowserRouter>
  <App />
</BrowserRouter>
</>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
